import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { Percent } from 'lucide-react';
import PageHeader from '../common/PageHeader';

// 관리자 — 글로벌 수수료 정산 현황 (글로벌 기획서 §6.1-1: 확정 인보이스 × 5%, 국내 수주측 청구)
const RATE = 0.05;

function AdminGlobalCommission() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const snap = await getDocs(query(collection(db, 'outsourceStatements'), where('isGlobal', '==', true)));
                setRows(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (e) { console.error('글로벌 명세서 로드 실패:', e); }
            finally { setLoading(false); }
        })();
    }, []);

    const inMonth = (r) => {
        const t = r.createdAt?.toDate ? r.createdAt.toDate() : null;
        return t && t.toISOString().slice(0, 7) === month;
    };
    const monthRows = rows.filter(r => inMonth(r) && r.status === 'published');

    // 국내 수주 기공소별 집계 (통화별 분리)
    const byLab = new Map();
    monthRows.forEach(r => {
        const key = `${r.fromUserId}|${r.currency || 'KRW'}`;
        if (!byLab.has(key)) byLab.set(key, { labName: r.fromUserName || r.fromUserId, currency: r.currency || 'KRW', total: 0, count: 0 });
        const g = byLab.get(key);
        g.total += Number(r.totalAmount || 0);
        g.count += 1;
    });

    const money = (n, cur) => `${cur} ${Number(n).toLocaleString('ko-KR', { maximumFractionDigits: 2 })}`;

    return (
        <div style={{ maxWidth: 860, margin: '0 auto', padding: 20 }}>
            <PageHeader icon={Percent} title="글로벌 수수료 정산 (5%)" />
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '14px 0' }}>
                <input type="month" value={month} onChange={e => setMonth(e.target.value)}
                    style={{ padding: '8px 12px', border: '1px solid #E4E6EE', borderRadius: 8, fontSize: 14 }} />
                <span style={{ fontSize: 13, color: '#5A6072' }}>발행(published) 명세서 기준 · 청구 대상 = 국내 수주 기공소</span>
            </div>

            {loading ? <div style={{ color: '#5A6072', padding: 30 }}>불러오는 중…</div> : (
                <div style={{ background: '#fff', border: '1px solid #E4E6EE', borderRadius: 12, overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
                        <thead><tr style={{ background: '#F8FAFC' }}>
                            {['수주 기공소', '건수', '인보이스 합계', '수수료 (5%)'].map(h =>
                                <th key={h} style={{ textAlign: 'left', padding: '10px 14px', fontSize: 12, color: '#64748B', borderBottom: '1px solid #E4E6EE' }}>{h}</th>)}
                        </tr></thead>
                        <tbody>
                            {byLab.size === 0 && <tr><td colSpan={4} style={{ padding: 26, textAlign: 'center', color: '#94A3B8' }}>해당 월 글로벌 명세서가 없습니다.</td></tr>}
                            {[...byLab.values()].map((g, i) => (
                                <tr key={i} style={{ borderBottom: '1px solid #F1F5F9' }}>
                                    <td style={{ padding: '10px 14px', fontWeight: 700 }}>{g.labName}</td>
                                    <td style={{ padding: '10px 14px' }}>{g.count}건</td>
                                    <td style={{ padding: '10px 14px', fontVariantNumeric: 'tabular-nums' }}>{money(g.total, g.currency)}</td>
                                    <td style={{ padding: '10px 14px', fontWeight: 800, color: '#4F52C7', fontVariantNumeric: 'tabular-nums' }}>{money(g.total * RATE, g.currency)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <p style={{ fontSize: 12.5, color: '#94A3B8', marginTop: 10 }}>
                수수료 청구서(세금계산서) 발행은 월마감 후 수동 진행 — 외화 인보이스는 청구 시점 환율로 원화 환산해 발행.
            </p>
        </div>
    );
}

export default AdminGlobalCommission;
